import React, { Fragment, useState, useEffect, useRef } from 'react';
import Image from "helpers/Image";
import { Link } from 'react-router-dom';
import "./style.css";
import joinPlanGif from '../../../../assets/Joinplan.gif'


const Header = () => {

    const [visible, setVisible] = useState(false);

    const popoverRef = useRef(null);

    const handleClickOutside = (event) => {
        if (popoverRef.current && !popoverRef.current.contains(event.target)) {
            setVisible(false);
        }
    };

    const handleClick = () => {
        setVisible(!visible);
    };

    const navItems = [
        { name: 'HOME', link: '/home' },
        { name: 'ABOUT US', link: '/about-us' },
        // { name: 'COLLECTION', link: '/collection' },
        // { name: 'PURCHASE PLAN', link: '/purchase-plan' },
        // { name: 'CONTACT US', link: '/contact-us' },
    ]

    useEffect(() => {
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    return (
        <Fragment>
            <header className="web-header" ref={popoverRef}>
                <nav className="miniNavContainer">
                <section>
                    <div className="miniNavItem start">
                        <div className="brand">
                        <Image name="android.png" />
                          
                        </div>
                        <div className="brand">
                        <Image name="apple.png" />
                         
                        </div>
                    </div>
                    <div className='miniNavItem'>
                        <span>Today's Rate :</span>
                        <strong>Gold 22K : 7100/Gram</strong>
                        <strong className="silver">Silver : 95.50/Gram</strong>
                    </div>
                    <div className="miniNavItem end">
                        <img src={joinPlanGif} alt=''></img>
                    </div>
                </section>
            </nav>
            <nav className="navContainer">
                <section>
                    <div className='logoContainer'>
                                
                        <Image className='LOGO' name="owner_image.png" />
                        
                        <div className='appName'>
                            <h1>N.R JEWELLERS</h1>
                            <h1></h1>
                        </div>
                    
                    </div>
                    <ul>
                        {navItems.map((item, index) => (
                            <Link to={item.link} key={index}>
                                <li>{item.name}</li>
                            </Link>
                        ))}
                    </ul>
                </section>
            </nav>
          
            </header>
          
        </Fragment>
    )
}

export default Header;